module.exports = __webpack_public_path__ + "assets_app/img/button-keypad.63b3fa22.svg";